<template>
  <div class="page">
    <!-- <mt-header fixed title="选择办理时间" class="music-header">
            <fallback slot="left"></fallback>
        </mt-header> -->
    <div class="page-content">
      <section class="wh_container">
        <div class="wh_content_all">
          <div class="wh_top_changge">
						<!-- 左箭头 -->
            <li @click="PreMonth(myDate, false)">
              <div class="wh_jiantou1"></div>
            </li>
						<!-- 日期标题 -->
            <li class="wh_content_li">{{ dateTop }}</li>
						<!-- 右箭头 -->
            <li @click="NextMonth(myDate, false)">
              <div class="wh_jiantou2"></div>
            </li>
          </div>
          <!-- 周一到周日 -->
          <div class="wh_content">
            <div class="wh_content_item" v-for="tag in textTop">
              <div class="wh_top_tag">
                {{ tag }}
              </div>
            </div>
          </div>
          <!-- 日期日历 -->
          <div class="wh_content">
            <div
              class="wh_content_item"
              v-for="(item, index) in list"
              @click="clickDay(item, index)"
            >
              <div
                class="wh_item_date"
                v-bind:class="[
                  { wh_isMark: item.isMark },
                  {
                    wh_other_dayhide: item.otherMonth !== 'nowMonth',
                  },
                  { wh_want_dayhide: item.dayHide },
                  { wh_isToday: item.isToday },
                  { wh_chose_day: item.chooseDay },
                  setClass(item),
                ]"
              >
                {{ item.id }}
              </div>
            </div>
          </div>
          <div
            style="
              text-align: center;
              margin-top: 20px;
              display: flex;
              justify-content: center;
              height: 41px;
              line-height: 41px;
            "
          >
            <span
              v-bind:class="{
                dayPartType1: amSelect && !pmSelect,
                dayPartType2: !amSelect && pmSelect,
              }"
              @click="chooseDayPartType(1)"
              style="border-radius: 10px 0 0 10px; padding: 0px 30px"
              >上午</span
            >
            <span
              v-bind:class="{
                dayPartType1: pmSelect && !amSelect,
                dayPartType2: !pmSelect && amSelect,
              }"
              @click="chooseDayPartType(2)"
              style="border-radius: 0 10px 10px 0; padding: 0px 30px"
              >下午</span
            >
          </div>
          <div
            :style="{ height: swipeHeight }"
            style="margin: 20px 0px 10px 0px"
          >
            <mt-swipe
              :auto="0"
              ref="swipe"
              autoHeight
              :show-indicators="false"
              :defaultIndex="defaultIndex"
              @change="handleChange"
            >
              <mt-swipe-item>
                <div ref="periodlist1" class="itemlist">
                  <div
                    class="period"
                    v-bind:class="[
                      { period_selected: item.selected },
                      {
                        period_cant_select: item.num == 0,
                      },
                      {
                        period_margin_zero: (index + 1) % 3 == 0,
                      },
                    ]"
                    v-for="(item, index) in amlist"
                    :key="`am${index}`"
                    @click="clickPeriod(item)"
                  >
                    <div>{{ item.period }}</div>
                    <div style="display: flex; justify-content: center">
                      <span v-if="item.num !=0">{{ "(" + item.num + "/" + item.total + ")" }}</span>
                      <span v-else>（约满）</span>
                    </div>
                  </div>
                </div>
              </mt-swipe-item>
              <mt-swipe-item>
                <div ref="periodlist2" class="itemlist">
                  <div
                    class="period"
                    v-bind:class="[
                      { period_selected: item.selected },
                      {
                        period_cant_select: item.num == 0,
                      },
                      {
                        period_margin_zero: (index + 1) % 3 == 0,
                      },
                    ]"
                    v-for="(item, index) in pmlist"
                    :key="`pm${index}`"
                    @click="clickPeriod(item)"
                  >
                    <div>{{ item.period }}</div>
                    <div style="display: flex; justify-content: center" >
                      <span v-if="item.num !=0">{{ "(" + item.num + "/" + item.total + ")" }}</span>
                      <span v-else>（约满）</span>
                    </div>
                  </div>
                </div>
              </mt-swipe-item>
            </mt-swipe>
          </div>
        </div>
      </section>
      <div v-if="datelist && datelist.length">
        <div style="margin: 30px 20px 20px 20px">
          <div class="blue-date-btn" @click="clickSubmit">确定</div>
          <!-- <van-button type="primary"   color="" block style="fontSize: 18px;borderRadius: 8px;backgroundColor: $blue">确定</van-button> -->
        </div>
      </div>
      <div v-else style="margin: 20px; text-align: center">
        {{ timeDesc }}
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from "mint-ui";
import { reserveDateList } from "@/api/index";
import { mapState, mapMutations, mapActions } from "vuex";
const NameSpace = "module";

import timeUtil from "./calendar";

export default {
  name: "appoDate",
  data() {
    return {
      myDate: [],
      list: [],
      dateTop: "",
      defaultIndex: 0,
      amSelect: true,
      pmSelect: false,
      datelist: [],
      amlist: [],
      pmlist: [],
      historyChose: [],
      selectPeriod: {
        startTime: "",
        endTime: "",
        theDate: "",
      },
      swipeHeight: "",
      timeDesc: "",
    };
  },
  props: {
    markDate: {
      type: Array,
      default: () => [],
    },
    markDateMore: {
      type: Array,
      default: () => [],
    },
    textTop: {
      type: Array,
      default: () => ["日", "一", "二", "三", "四", "五", "六"],
    },
    sundayStart: {
      type: Boolean,
      default: () => true,
    },
    agoDayHide: { type: String, default: `0` },
    futureDayHide: { type: String, default: `2554387200` },
  },
 mounted() {
	 setTimeout(()=>{	//延时隐藏智桂通顶部页面
		 	 $("#ucBtn").hide();
	 },2000);
 },
  created() {
	  	
    if (!this.$route.query.bizId) {
      // this.$router.go(-1);
      this.$router.push({ path: "service" });
      return;
    }
    if (this.$isWeiXin) {
      this.$isFocus(this.$route.params.clientId);
    }
    reserveDateList(this.$route.query.bizId,this.$route.query.bizTypeId).then((response) => {
      this.datelist = response.data;
      this.intStart();
      if (response.data && response.data.length) {
        this.myDate = timeUtil.stringToDate(this.datelist[0].date);
        this.getList(this.myDate);

        this.clickDay(
          {
            date: this.datelist[0].date,
            otherMonth: "nowMonth",
            dayHide: false,
          },
          this.datelist[0].date
        );
      } else {
        this.myDate = new Date();
        this.getList(this.myDate);

        if (!this.amlist || !this.amlist.length) {
          this.timeDesc = "当前业务没有可以选择的预约日期";
        }
      }
    });

  },
  methods: {
    chooseDayPartType(type) {
      let length = type == 1 ? this.amlist.length : this.pmlist.length;
      let num = (length / 3) * 90;

      if (type == 1) {
        this.amSelect = true;
        this.pmSelect = false;
        this.defaultIndex = 0;
        this.$refs.swipe.swipeItemCreated();
      } else {
        this.pmSelect = true;
        this.amSelect = false;
        this.defaultIndex = 1;
        this.$refs.swipe.swipeItemCreated();
      }

			if(num < 70) {
				num = 70
			}
      this.$nextTick(() => {
        this.swipeHeight = num + "px";
      });
    },
    handleChange(index) {
      if (index == 0) {
        this.amSelect = true;
        this.pmSelect = false;
      } else {
        this.pmSelect = true;
        this.amSelect = false;
      }
    },
    intStart() {
      timeUtil.sundayStart = this.sundayStart;
    },
    setClass(data) {
      let obj = {};
      obj[data.markClassName] = data.markClassName;
      return obj;
    },
    clickSubmit: function () {
      var query = this.$route.query;
      if (!this.selectPeriod.startTime) {
        Toast({
          message: "请选择办理时间",
          position: "center",
          duration: 2000,
        });
        return;
      }

      this.$router.push({
        path: `reserveConfirm?bizId=${query.bizId}&bizTypeId=${query.bizTypeId}&netId=${query.netId}&bizName=${query.bizName}&theDate=${this.selectPeriod.theDate}&startTime=${this.selectPeriod.startTime}&endTime=${this.selectPeriod.endTime}&affairId=${query.affairId}`,
      });
    },
    clickPeriod: function (item) {
      if (item.num == 0) {
        return;
      }
      let timelist = item.period.split("-");
      this.selectPeriod.startTime = timelist[0];
      this.selectPeriod.endTime = timelist[1];

      this.amlist.forEach((iitem, index) => {
        iitem.selected = false;
      });
      this.pmlist.forEach((iitem, index) => {
        iitem.selected = false;
      });
      item.selected = true;
    },
    clickDay: function (item, index) {
      if (item.otherMonth === "nowMonth" && !item.dayHide) {
        var self = this;
        this.selectPeriod.startTime = "";
        this.selectPeriod.endTime = "";
        this.amlist = [];
        this.pmlist = [];
        this.timeDesc = "";

        for (var i = 0; i < this.datelist.length; i++) {
          if (this.datelist[i].date == timeUtil.dateFormat(item.date)) {
            this.datelist[i].am.forEach((iitem, index) => {
              iitem.selected = false;
            });
            this.datelist[i].pm.forEach((iitem, index) => {
              iitem.selected = false;
            });

            this.amlist = this.datelist[i].am;
            this.pmlist = this.datelist[i].pm;

            if (!this.amlist || !this.amlist.length) {
              this.timeDesc = "当前日期没有可以预约的时段";
            }
            this.isSelect = false;

            setTimeout(function () {
              var height1 = self.$refs.periodlist1.offsetHeight;
              var height2 = self.$refs.periodlist2.offsetHeight;
              if (!height1 || height2 > height1) {
                self.swipeHeight = height2 + 5 + "px";
              } else {
                self.swipeHeight = height1 + 5 + "px";
              }
            }, 10);

            this.getList(this.myDate, item.date);
            this.selectPeriod.theDate = item.date;
          }
        }
      }
      /*if (item.otherMonth !== 'nowMonth') {
                    item.otherMonth === 'preMonth'
                        ? this.PreMonth(item.date)
                        : this.NextMonth(item.date);
                }*/
    },
    ChoseMonth: function (date, isChosedDay = true) {
      date = timeUtil.dateFormat(date);
      this.myDate = new Date(date);
      this.$emit("changeMonth", timeUtil.dateFormat(this.myDate));
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay);
      } else {
        this.getList(this.myDate);
      }
    },
    PreMonth: function (date, isChosedDay = true) {
      date = timeUtil.dateFormat(date);
			// console.log(date,5555);
      this.myDate = timeUtil.getOtherMonth(this.myDate, "preMonth");
      this.$emit("changeMonth", timeUtil.dateFormat(this.myDate));
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay);
      } else {
        this.getList(this.myDate);
      }
    },
    NextMonth: function (date, isChosedDay = true) {
      date = timeUtil.dateFormat(date);
			// console.log(date,5555);
      this.myDate = timeUtil.getOtherMonth(this.myDate, "nextMonth");
      this.$emit("changeMonth", timeUtil.dateFormat(this.myDate));
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay);
      } else {
        this.getList(this.myDate);
      }
    },
    forMatArgs: function () {
      let markDate = this.markDate;
      let markDateMore = this.markDateMore;
      markDate = markDate.map((k) => {
        return timeUtil.dateFormat(k);
      });
      markDateMore = markDateMore.map((k) => {
        k.date = timeUtil.dateFormat(k.date);
        return k;
      });
      return [markDate, markDateMore];
    },
    getList: function (date, chooseDay, isChosedDay = true) {
      const [markDate, markDateMore] = this.forMatArgs();
      this.dateTop = `${date.getFullYear()}年${date.getMonth() + 1}月`;
      let arr = timeUtil.getMonthList(this.myDate);
      for (let i = 0; i < arr.length; i++) {
        let markClassName = "";
        let k = arr[i];
        k.chooseDay = false;
        const nowTime = k.date;
        const t = new Date(nowTime).getTime() / 1000;
        //看每一天的class
        for (const c of markDateMore) {
          if (c.date === nowTime) {
            markClassName = c.className || "";
          }
        }
        //标记选中某些天 设置class
        k.markClassName = markClassName;
        k.isMark = markDate.indexOf(nowTime) > -1;
        //无法选中某天
        k.dayHide = t < this.agoDayHide || t > this.futureDayHide;
        if (k.isToday) {
          this.$emit("isToday", nowTime);
        }
        var datestr = timeUtil.dateFormat(k.date);
        let isContain = false;

        this.datelist.forEach((item, index) => {
          if (item.date == datestr) {
            isContain = true;
          }
        });
        if (!isContain) {
          k.otherMonth = "nextMonth";
        }
        let flag = !k.dayHide && k.otherMonth === "nowMonth";
        if (chooseDay && chooseDay === nowTime && flag) {
          this.$emit("choseDay", nowTime);
          this.historyChose.push(nowTime);
          k.chooseDay = true;
        } else if (
          this.historyChose[this.historyChose.length - 1] === nowTime &&
          !chooseDay &&
          flag
        ) {
          k.chooseDay = true;
        }
      }
      this.list = arr;
    },
  } /*
        mounted() {
            this.getList(this.myDate);
        },*/,
  watch: {
    markDate: {
      handler(val, oldVal) {
        this.getList(this.myDate);
      },
      deep: true,
    },
    markDateMore: {
      handler(val, oldVal) {
        this.getList(this.myDate);
      },
      deep: true,
    },
    agoDayHide: {
      handler(val, oldVal) {
        this.agoDayHide = parseInt(val);
        this.getList(this.myDate);
      },
      deep: true,
    },
    futureDayHide: {
      handler(val, oldVal) {
        this.futureDayHide = parseInt(val);
        this.getList(this.myDate);
      },
      deep: true,
    },
    sundayStart: {
      handler(val, oldVal) {
        this.intStart();
        this.getList(this.myDate);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.itemlist {
  width: 345px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-flow: row wrap;
  // justify-content: space-between;
}
.dayPartType1 {
  background-color: $blue;
  border-radius: 14px;
  font-size: 19px;
  padding: 2px 20px;
  color: #fff;
  text-align: center;
  display: inline-block;
}
.dayPartType2 {
  background-color: #f5f5f5;
  border-radius: 14px;
  font-size: 19px;
  padding: 2px 20px;
  color: $blue;
  text-align: center;
  display: inline-block;
}
.period {
  width: 105px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  flex-direction: column;
  font-size: 15px;
  background-color: #e2efff;
  color: $blue;
  margin-bottom: 20px;
  margin-right: 10px;
}
.period_margin_zero {
  margin-right: 0;
}
.period span {
  font-size: 12px;
}
.period_cant_select {
  background-color: #f5f5f5;
  color: #a8a8a8;
}
.period_selected {
  background-color: $blue;
  color: #fff;
}
.period_selected img {
  display: block;
}
.period_can_select {
  border: 1px solid darkslategray;
}
</style>
<style lang="scss" scoped>
@media screen and (min-width: 460px) {
  .wh_item_date:hover {
    background: #71c7a5;
    cursor: pointer;
  }
}
* {
  margin: 0;
  padding: 0;
}

.wh_container {
  max-width: 410px;
  margin: auto;
}

li {
  list-style-type: none;
}
.wh_top_changge {
  display: flex;
}

.wh_top_changge li {
  cursor: pointer;
  display: flex;
  font-size: 18px;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 47px;
}

.wh_top_changge .wh_content_li {
  cursor: auto;
  flex: 2.5;
}
.wh_content_all {
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
    "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  background-color: #ffffff;
  width: 100%;
  overflow: hidden;
  padding-bottom: 8px;
}

.wh_content {
  display: flex;
  flex-wrap: wrap;
  padding: 0 3% 0 3%;
  width: 100%;
}

.wh_content:first-child .wh_content_item_tag,
.wh_content:first-child .wh_content_item {
  color: #ddd;
  font-size: 16px;
}

.wh_content_item,
wh_content_item_tag {
  font-size: 15px;
  width: 13.4%;
  text-align: center;
  position: relative;
}
.wh_content_item {
  height: 40px;
}

.wh_top_tag {
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.wh_item_date {
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.wh_jiantou1 {
  width: 12px;
  height: 12px;
  border-top: 2px solid $blue;
  border-left: 2px solid $blue;
  transform: rotate(-45deg);
}

.wh_jiantou1:active,
.wh_jiantou2:active {
  border-color: #ddd;
}

.wh_jiantou2 {
  width: 12px;
  height: 12px;
  border-top: 2px solid $blue;
  border-right: 2px solid $blue;
  transform: rotate(45deg);
}
.wh_content_item > .wh_isMark {
  margin: auto;
  border-radius: 100px;
  background: blue;
  z-index: 2;
}
.wh_content_item .wh_other_dayhide {
  color: #bfbfbf;
}
.wh_content_item .wh_want_dayhide {
  color: #bfbfbf;
}
.wh_content_item .wh_isToday {
  color: blue;
  border-radius: 100px;
}
.wh_content_item .wh_chose_day {
  background: $blue;
  color: #fff;
  border-radius: 100px;
  /* box-shadow: #90C1F4 0px 0px 5px 3px; */
}
.dayPartType1 {
  border-radius: 20px 0px 0px 20px;
  padding: 7px 20px;
}
</style>
<style lang="scss" scoped>
.singer-list-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: -1;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
.blue-date-btn {
  background-color: $blue;
  height: 44px;
  font-size: 18px;
  color: #fff;
  text-align: center;
  line-height: 44px;
  border-radius: 8px;
}
</style>
